import { useEffect, useState } from 'react';

type Theme = 'system' | 'light' | 'dark';
const STORAGE_KEY = 'em-theme';

/** Di base segue il sistema; la scelta esplicita vince e resta memorizzata. */
export function useTheme(): [Theme, (t: Theme) => void] {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem(STORAGE_KEY) as Theme | null) ?? 'system',
  );

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'system') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return [theme, setTheme];
}

export function ThemeToggle() {
  const [theme, setTheme] = useTheme();
  const options: { value: Theme; label: string }[] = [
    { value: 'light', label: 'Chiaro' },
    { value: 'system', label: 'Auto' },
    { value: 'dark', label: 'Scuro' },
  ];

  return (
    <div
      role="group"
      aria-label="Tema"
      className="grid grid-cols-3 gap-1 rounded-[var(--radius-control)] bg-surface-2 p-1"
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => setTheme(o.value)}
          aria-pressed={theme === o.value}
          className={`rounded-lg px-2 py-1.5 text-xs font-medium transition ${
            theme === o.value ? 'bg-surface text-text shadow-sm' : 'text-muted'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
